export default import.meta.ROLLDOWN_FILE_URL_88dJQ2rTX0iCDc3QQ4neqg